import { render, staticRenderFns } from "./cart-badge.vue?vue&type=template&id=fe2fd020&"
import script from "./cart-badge.vue?vue&type=script&lang=js&"
export * from "./cart-badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports